import {
    getProxiedServiceUrl
} from 'gw-portals-url-js';
import {
    JsonRPCService
} from 'gw-portals-transport-js';
import {
    getProxiedUrl
} from 'gw-portals-url-js';

export default class SasriaAgentSignupService {
    static agentSignup(givenName, familyName, userName, email, password, useraccess, loggedInAdmin) {
        const params = {
            name: {
                givenName,
                familyName
            },
            emails: [{
                value: email,
                primary: true
            }],
            userName,
            password
        };

        return JsonRPCService.send(getProxiedUrl('signup'), 'createAgent_EXT', [params, useraccess, loggedInAdmin])
            .then((response) => {
                if (response.error == null) {
                    (this.setPassword(email, null))
                }
            })
            .catch((error) => {
                const errorCode = error.baseError.error.message.match(/[0-9]+/gi);
                // user already exists if error message return code 409
                if (errorCode && errorCode.includes('409')) {
                    return Promise.reject({
                        error: ERRORS.userAlreadyExists
                    });
                }
                return Promise.reject(error);
            });
    }

    static setPassword(email, additionalHeaders = {}) {
        const authResetPath = '/producer-engage-claims/auth/resetpassword';
        const newPasswordEntryUrl = `${window.location.origin}${authResetPath}`;
        const params = [{
            email,
            newPasswordEntryUrl
        }];

        return JsonRPCService.send(getProxiedUrl('resetpassword'), 'updatePasswordToken_EXT', params, additionalHeaders)
            .then((res) => ({
                res: res
            }))
            .catch((error) => {
                // email does not exists when error message return code 404
                if (isErrorCode(error.baseError, '404')) {
                    return Promise.reject({
                        error: ERRORS.emailNotFound
                    });
                }
                return Promise.reject(error);
            });
    }

    static isProducerAdmin(userName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedUrl('signup'),
            'checkIfProducerAdmin_EXT', [userName], additionalHeaders);
    }

    static updateUser(userName, firstName, lastName,useraccessSet, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedUrl('signup'),
            'updateUserFromPE_EXT', [userName, firstName, lastName, useraccessSet], additionalHeaders);
    }

    static deactivateUser(userName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedUrl('signup'),
            'deactivateUser_EXT', [userName], additionalHeaders);
    }


    static getUserSummary(userName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedUrl('signup'),
            'getAgentUserSummaries_EXT', [userName], additionalHeaders);
    }

    static isAccessPresentInPE(userName, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedUrl('signup'),
            'checkAccessForPE_EXT', [userName], additionalHeaders);
    }

    static changeMainContactOnDeactivation_EXT(deactivatedEmail, firstname, lastname, emailId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedUrl('signup'),
            'changeMainContactOnDeactivation_EXT', [deactivatedEmail, firstname, lastname, emailId], additionalHeaders);
    }



}